"use strict";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const container = document.querySelector(".o-solutions-circle__inner");
        const items = document.querySelectorAll(".o-solutions-circle__item");
        if (!container || !items.length) return;

        const bulletSize = 64; // diâmetro da bullet (px) — mantenha igual ao CSS
        const gap = 40; // distância do texto para fora do círculo (px)
        const EPS = 0.03; // ~1.7° de tolerância angular para evitar sobreposição

        const placeAll = () => {
            const circleSize = container.offsetWidth;
            const R = circleSize / 2; // raio do círculo (do centro até a borda)

            items.forEach((item) => {
                const angleDeg = parseFloat(
                    item.style.getPropertyValue("--angle")
                );
                const angleRad = (angleDeg * Math.PI) / 180;

                // Posição do CENTRO da bullet SOBRE a borda
                const cx = R + R * Math.cos(angleRad);
                const cy = R + R * Math.sin(angleRad);
                item.style.left = `${cx}px`;
                item.style.top = `${cy}px`;
                item.style.transform = "translate(-50%, -50%)";

                // Limpa classes anteriores
                item.classList.remove(
                    "is-top",
                    "is-right",
                    "is-bottom",
                    "is-left"
                );

                // ----- CLASSIFICAÇÃO ROBUSTA -----
                const c = Math.cos(angleRad);
                const s = Math.sin(angleRad);

                // 1) Força o primeiro item (topo). Seu ângulo é -90° (ou 270°)
                if (
                    Math.abs(angleDeg + 90) <= 0.6 ||
                    Math.abs(angleDeg - 270) <= 0.6
                ) {
                    item.classList.add("is-top");
                } else {
                    // 2) Usa o sinal do cos para direita/esquerda (evita sobrepor)
                    if (c > EPS) {
                        item.classList.add("is-right");
                    } else if (c < -EPS) {
                        item.classList.add("is-left");
                    } else {
                        // 3) Se cos ~ 0, decide por cima/baixo via sin
                        if (s > 0) item.classList.add("is-bottom");
                        else item.classList.add("is-top");
                    }
                }

                // ----- POSICIONAMENTO DO CONTEÚDO -----
                const info = item.querySelector(
                    ".o-solutions-circle__item-info"
                );
                if (!info) return;

                info.style.position = "absolute";
                info.style.left = "50%";
                info.style.top = "50%";

                if (item.classList.contains("is-top")) {
                    // conteúdo acima da bullet, centralizado
                    info.style.transform = `translate(-50%, calc(-100% - ${gap}px))`;
                    info.style.textAlign = "center";
                    info.style.display = "flex";
                    info.style.flexDirection = "column";
                    info.style.alignItems = "center";
                } else if (item.classList.contains("is-bottom")) {
                    // conteúdo abaixo da bullet, centralizado
                    info.style.transform = `translate(-50%, ${gap}px)`;
                    info.style.textAlign = "center";
                    info.style.display = "flex";
                    info.style.flexDirection = "column";
                    info.style.alignItems = "center";
                } else if (item.classList.contains("is-right")) {
                    // conteúdo à direita da bullet, alinhado à esquerda
                    info.style.transform = `translate(${
                        gap + bulletSize / 2
                    }px, -50%)`;
                    info.style.textAlign = "left";
                    info.style.display = "flex";
                    info.style.flexDirection = "column";
                    info.style.alignItems = "flex-start";
                } else if (item.classList.contains("is-left")) {
                    // conteúdo à esquerda da bullet, alinhado à direita
                    info.style.transform = `translate(calc(-100% - ${
                        gap + bulletSize / 2
                    }px), -50%)`;
                    info.style.textAlign = "right";
                    info.style.display = "flex";
                    info.style.flexDirection = "column";
                    info.style.alignItems = "flex-end";
                }
            });
        };

        // inicial e em resize (mantém perfeito quando a largura muda)
        placeAll();
        window.addEventListener("resize", placeAll, {
            passive: true,
        });
    });
}
